import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import UpcomingProgramsDataTable from './components/UpcomingProgramsDataTable';
import AcademicProgramsDataTable from './components/AcademicProgramsDataTable';
import { getAcademicPrograms, getContactInfo } from '../../utils/ApiService';
import Header from '../Header';
import { useLocation, useHistory } from 'react-router-dom';
import moment from 'moment';
//for upcoming adacemic programs
var today = moment();

// const startDate = moment(nodes.StartDate);
// const endDate = moment(nodes.EndDate);

const useStyles = makeStyles((theme) => ({
  table: {
    margin: 52,
    [theme.breakpoints.down('md')]: {
      marginTop: 52,
      marginRight: 12,
      marginLeft: 12,
    },
  },
}));

const AcademicPrograms = (props) => {
  const classes = useStyles();
  const [loading, setLoading] = useState(true);
  const [programs, setPrograms] = useState([]);
  const [user, setUser] = useState();
  const history = useHistory();
  const [institute, setInstitute] = useState('');
  const [upcomingPrograms, setUpcoming] = useState([]);

  const routerState = useLocation();
  //console.log('[Programs] Router State:', routerState);

  //get the academic programs
  useEffect(() => {
    localStorage.removeItem('AppID');
    localStorage.removeItem('relation');
    localStorage.removeItem('StudentID');
    const userDetails = history?.location?.state?.userDetails || {};
    getContactInfo(localStorage.getItem('contactID')).then((res) => {
      setUser({ ...res, ...userDetails });
      // setUser(res);
      setLoading(false);
    });
    getAcademicPrograms().then((response) => {
      // console.log('Academic Programs:', response);
      if (Array.isArray(response) && response.length > 0) {
        setInstitute(response[0].Institute);
      }
      let prog = [];
      let upCom = [];
      response.map((element) => {
        if (
          moment(element.StartDate) <= today &&
          today <= moment(element.EndDate)
        ) {
          prog.push(element);
        } else if (today < moment(element.StartDate)) {
          upCom.push(element);
        }
      });
      // setPrograms(prog.sort((a, b) => b.Sequence - a.Sequence));
      setPrograms(
        prog.sort(
          (a, b) =>
            (a.Sequence === null) - (b.Sequence === null) ||
            -(a.Sequence > b.Sequence) ||
            +(a.Sequence < b.Sequence)
        )
      );
      setUpcoming(upCom);
      setLoading(false);
    });
  }, []);

  //console.log("programs",programs);
  // handle the status change

  return (
    <div>
      <Header
        showRetrieve={true}
        home={true}
        isLogo={false}
        firstName={history?.location?.state?.userDetails?.First_Name}
        lastName={history?.location?.state?.userDetails?.Last_Name}
        title={institute}
      />
      <div className={classes.table}>
        <AcademicProgramsDataTable
          data={programs}
          loading={loading}
          user={user}
        />
        {/* <UpcomingProgramsDataTable
          data={upcomingPrograms}
          loading={loading}
          style={{ marginTop: "20px" }}
        /> */}
      </div>
    </div>
  );
};

export default AcademicPrograms;
